import { graphql, useStaticQuery } from 'gatsby'

export const getDepartments = () => {
  const data = useStaticQuery(graphql`
    query {
      departments {
        content {
          title
          footer {
            links {
              href
              target
              text
            }
            title {
              href
              target
              text
            }
          }
        }
      }
    }
  `)
  return data?.departments?.content || []
}
